import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Icon from 'components/common/Icon/Icon'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'

const WarrantyBadge = ({ treadLifeWarrantyValue, asset, className, width, height, small, isTreadLife }) =>
  <IconWrapper>
    {
      isTreadLife ?
        <TreadLifeWarrantyIconWrapper className={ className }>
          <Icon
            data-at-warrantyicon
            asset="tread-life-warranty-Badge"
            width={ width }
            height={ height }
            warranty={ treadLifeWarrantyValue }
            margin="-2px 8px 0 0" />
          <WarrantyValue small={ small }>{ treadLifeWarrantyValue }<Thousandth>k</Thousandth></WarrantyValue>
        </TreadLifeWarrantyIconWrapper> :
        <BadgeIcon data-at-warrantyicon className={ className } width={ width } height={ height } asset={ asset } />
    }
  </IconWrapper>


WarrantyBadge.propTypes = {
  asset: PropTypes.string,
  className: PropTypes.string,
  height: PropTypes.string,
  isTreadLife: PropTypes.bool,
  small: PropTypes.bool,
  treadLifeWarrantyValue: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.bool
  ]),
  width: PropTypes.string
}

export default WarrantyBadge

const TreadLifeWarrantyIconWrapper = styled.div`
  display: inline-block;
  position: relative;
`

const WarrantyValue = styled.div`
  position: absolute;
  left: 14px;
  top: 10px;
  ${Mixin.font.GothamBold(19)}
  ${props => props.small && css`
    left: 12px;
    top: 6px;
    ${Mixin.font.GothamBold(14)}
  `}
`

const Thousandth = styled.span`
  ${Mixin.font.GothamBold(12)}
`

const IconWrapper = styled.div`
  padding-top: 2px;
  ${Media.desktop`
    text-align: center;
  `}
`

const BadgeIcon = styled(Icon)`
  display: block;
  margin: 0 auto;
`

